<template>
  <div>
    <provider-table
        ref="table"
        :url="indexUrl"
        :can-create="canCreate"
        :create-url="createUrl"
    ></provider-table>
    <dialog-form-wrapper></dialog-form-wrapper>
  </div>
</template>

<script>
import DialogFormWrapper from '../dialog-form-wrapper';
import ProviderTable from './table';

export default {
  components: {
    DialogFormWrapper,
    ProviderTable,
  },

  props: {
    indexUrl: null,
    createUrl: null,
    canCreate: {
      type: Boolean,
      default: false
    },
  },
}
</script>
